export default __webpack_public_path__ + "static/media/profile3.9eacff97.jpeg";